module.exports = __webpack_public_path__ + "files/ca14b8505b635949f023a4e8bfbec13a.png";